<template>
  <div class="row card borderless-card" style="box-shadow: none">
    <div class="col-12 layoutPadding-30" style="/*padding:0*/">
      <div
        class="row mb-3"
        style="justify-content: space-between; margin: auto"
      >
        <div class="team-title mt-2 d-flex">
          <div
            class="companyProfileCardsAddButton"
            style="padding-top:5px;margin-right: 10px;"
            @click="handleBack"
          >
            <i class="fa fa-arrow-left"></i>
          </div>
          <div style="margin-top: auto; margin-bottom: auto">Checklist</div>
        </div>
        <div
          class="d-flex companyProfileCardsAddButton"
          @click="handleCreateChecklist"
        >
          <div>
            <i class="fa fa-plus" style="font-size: 8px"></i>
          </div>
          <div>Add</div>
        </div>
        <div class="mt-2"></div>
      </div>
    </div>

    <div class="col-12">
      <card class="checklist-card half" v-if="checklist">
        <div class="checklist-row">
          <div class="flex-row summary">
            <div>
              <div class="flex-row name-wrapper checklist-name-wrapper">
                <checklist-name :checklist="checklist" @refresh="getChecklistByPortfolio" :isDetails="true" :currentCompany="currentCompany"></checklist-name>

                <div
                  class="d-flex companyProfileCardsAddButton add-desc add-description"
                  @click="handleAddDescription"
                >
                  <div>Add Description</div>
                </div>
              </div>
              <div class="count" style="padding-left: 10px;">
                {{ completedChecklistItemCount(checklist.checklist_items) }}
                / {{ checklist.checklist_items.length }} Completed
              </div>
            </div>

            <span class="flex-auto"></span>

            <div class="progress-wrapper">
              <div class="progress-outer">
                <div
                  class="progress"
                  v-bind:style="{
                    width:
                      (completedChecklistItemCount(checklist.checklist_items) *
                        100) /
                        (checklist.checklist_items.length || 1) +
                      '%'
                  }"
                >
                  {{
                    Math.ceil(
                      (completedChecklistItemCount(checklist.checklist_items) *
                        100) /
                        (checklist.checklist_items.length || 1)
                    ) + "%"
                  }}
                </div>
              </div>
            </div>
            <div v-if="checklist">
              <el-dialog
                center
                width="400px"
                :closeOnClickModal="false"
                :closeOnPressEscape="false"
                :showClose="true"
                :visible.sync="deleteChecklist"
              >
                <div
                  class="row"
                  style="padding-left: 15px; padding-right: 15px"
                >
                  <div style="padding-left: 30px">
                    Are you sure you want to delete this Checklist?
                  </div>
                </div>
                <div class="col-12 d-flex">
                  <div
                    class="col-xl edit-company-action-button-row"
                    style="padding-right: 25px"
                  >
                    <button
                      type="button"
                      class="todo-form-cancel-button btn-outline-secondary"
                      @click.prevent="handleCancelDeleteChecklist"
                    >
                      Cancel
                    </button>
                    <button
                      @click="handleDeleteChecklist(checklist)"
                      class="todo-form-submit-button btn btn-primary"
                      style="height: 35px"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </el-dialog>
            </div>
            <div class="delete" @click="deleteChecklistModal(checklist)">
              <i class="fa fa-trash-alt pointer"></i>
            </div>
          </div>

          <div
            @dblclick="handleAddDescription"
            style="padding-left: 10px;margin-bottom: 20px;"
            class="discussion-input-value"
            v-if="checklist.description"
          >
            {{ checklist.description }}
          </div>

          <div v-if="showAddDescription">
            <div>
              <div class="team-title mt-2 d-flex">
                <div class="name pointer" style="font-size:14px;">
                  Description
                </div>
              </div>
              <div>
                <div class="col-12">
                  <Mentionable
                    :keys="['@']"
                    :items="people"
                    offset="6"
                    insert-space
                  >
                    <textarea
                      type="text"
                      placeholder="Add description to your checklist"
                      v-model="checklist.description"
                      :disabled="showSaveDiscussionSpinner"
                      class="discussion-input"
                    ></textarea>
                    <template #no-result>
                      <div class="dim">No result</div>
                    </template>

                    <template #item-@="{ item }">
                      <div class="user">
                        {{ item.firstName + " " + item.lastName }}
                      </div>
                    </template>
                  </Mentionable>
                </div>
              </div>

              <div
                class="col-3 edit-company-action-button-row"
                style="margin-top: 30px"
              >
                <button
                  type="button"
                  class="todo-form-cancel-button btn-outline-secondary"
                  @click.prevent="handleCancelDescription"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="todo-form-submit-button btn btn-primary"
                  @click.prevent="handleUpdateChecklistDescription"
                  :disabled="showSaveChecklistDescriptionSpinner"
                >
                  Save
                  <b-spinner
                    v-if="showSaveChecklistDescriptionSpinner"
                    style="float: right"
                    small
                    label="Loading..."
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>

          <div class="details">
            <div v-if="!checklist.checklist_items.length">
              <i class="no-data-msg">no checklist items added yet</i>
            </div>
            <div
              class="checklist-item-row-wrapper"
              v-for="(item, itmIdx) in checklist.checklist_items"
              :key="itmIdx"
            >
              <div class="checklist-item-row flex-row">
                <div class="checkbox">
                  <b-spinner
                    v-if="showSaveCheck && item.id == currentItemId"
                    style="float: right"
                    small
                    label="Loading..."
                  ></b-spinner>
                  <i
                    class="fa fa-square-o pointer"
                    @click="handleCheck(item, true)"
                    v-if="!item.is_done && item.id != currentItemId"
                  ></i>
                  <i
                    class="fa fa-check-square pointer"
                    @click="handleCheck(item, false)"
                    v-if="item.is_done && item.id != currentItemId"
                  ></i>
                </div>
                <div v-html="item.summary" class="checklist-item">
                  <!-- {{ item.summary }} -->
                </div>
                <span class="flex-auto"></span>
                <div class="comment-total">
                  <i class="fa fa-comment-o"></i>
                  {{ item.discussions.length }}
                </div>
                <div class="menu-wrapper">
                  <div
                    class="ellipsesDropdownLayout"
                    style="line-height: 13px;"
                  >
                    <b-dropdown
                      size="sm"
                      variant
                      right
                      class="company-card-dropdown"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template
                        v-slot:button-content
                        style="border: 0; background: none"
                      >
                        <i
                          class="fa fa-ellipsis-h"
                          aria-hidden="true"
                          style="color: #00000080"
                        ></i>
                      </template>
                      <b-dropdown-item @click="editChecklistItem(item)"
                        >Edit</b-dropdown-item
                      >
                      <b-dropdown-item @click="discussionChecklistItem(item)"
                        >Discussion</b-dropdown-item
                      >
                      <b-dropdown-item @click="deleteChecklistItem(item)"
                        >Delete</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
              </div>

              <div v-if="itemToEdit && itemToEdit.id == item.id">
                  <div class="col-12">
                    <Mentionable
                      :keys="['@']"
                      :items="people"
                      offset="6"
                      insert-space
                    >
                      <input
                        type="text"
                        class="form-control team-form"
                        style="width: 100%"
                        v-model="item.summary"
                        placeholder="Add a new checklist item"
                      />
                      <template #no-result>
                        <div class="dim">No result</div>
                      </template>

                      <template #item-@="{ item }">
                        <div class="user">
                          {{ item.firstName + " " + item.lastName }}
                        </div>
                      </template>
                    </Mentionable>
                    </div>

                <div
                  class="col-3 edit-company-action-button-row"
                  style="margin-top: 30px"
                >
                  <button
                    type="button"
                    class="todo-form-cancel-button btn-outline-secondary"
                    @click.prevent="handleCancelUpdateChecklistItem"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="todo-form-submit-button btn btn-primary"
                    @click.prevent="handleUpdateChecklistItem(item)"
                    :disabled="showSaveChecklistItemSpinner"
                  >
                    Save
                    <b-spinner
                      v-if="showSaveChecklistItemSpinner"
                      style="float: right"
                      small
                      label="Loading..."
                    ></b-spinner>
                  </button>
                </div>
              </div>

              <div class="discussion-wrapper">
                <div>
                  <div
                    class="discussion-row"
                    v-for="(discussion, disIdx) in item.discussions"
                    :key="disIdx"
                  >
                    <div class="flex-row">
                      <div
                        class="discussion-user-name"
                        v-if="idWiseUsers[discussion.created_by]"
                      >
                        {{
                          idWiseUsers[discussion.created_by].account.firstName +
                            " " +
                            idWiseUsers[discussion.created_by].account.lastName
                        }}
                      </div>
                      <div class="discussion-user-date">
                        {{
                          moment(discussion.created).format(
                            "MM-DD-YYYY hh:mm A"
                          )
                        }}
                      </div>
                    </div>
                    <div class="discussion-text flex-row">
                      <div>
                        {{ discussion.description }}
                      </div>
                      <span class="flex-auto"></span>
                      <div>
                        <div class="menu-wrapper">
                          <div class="ellipsesDropdownLayout">
                            <b-dropdown
                              size="sm"
                              variant
                              right
                              class="company-card-dropdown"
                              toggle-class="text-decoration-none"
                              no-caret
                            >
                              <template
                                v-slot:button-content
                                style="border: 0; background: none"
                              >
                                <i
                                  class="fa fa-ellipsis-h"
                                  aria-hidden="true"
                                  style="color: #00000080"
                                ></i>
                              </template>
                              <b-dropdown-item
                                @click="editDiscussionItem(discussion, item)"
                                >Edit</b-dropdown-item
                              >
                              <b-dropdown-item
                                @click="discussionChecklistItem(item)"
                                >Discussion</b-dropdown-item
                              >
                              <b-dropdown-item
                                @click="deleteDiscussionItem(discussion, item)"
                                >Delete</b-dropdown-item
                              >
                            </b-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        showDicussionEdit &&
                          activeDiscussionEditItem.id == discussion.id
                      "
                    >
                      <Mentionable
                        :keys="['@']"
                        :items="people"
                        offset="6"
                        insert-space
                      >
                        <textarea
                          type="text"
                          placeholder="Message ..."
                          v-model="discussion.description"
                          :disabled="showSaveDiscussionSpinner"
                          class="discussion-input"
                          @keyup.enter.exact="
                            handleDiscussionUpdate(item, discussion)
                          "
                        ></textarea>
                        <template #no-result>
                          <div class="dim">No result</div>
                        </template>

                        <template #item-@="{ item }">
                          <div class="user">
                            {{ item.firstName + " " + item.lastName }}
                          </div>
                        </template>
                      </Mentionable>
                    </div>
                  </div>
                </div>

                <div v-if="showDicussion && activeDiscussionItem.id == item.id">
                  <Mentionable
                    :keys="['@']"
                    :items="people"
                    offset="6"
                    insert-space
                  >
                    <textarea
                      type="text"
                      placeholder="Message ..."
                      v-model="item.discussionText"
                      :disabled="showSaveDiscussionSpinner"
                      class="discussion-input"
                      @keyup.enter.exact="handleDiscussionCreate(item)"
                    ></textarea>

                    <template #no-result>
                      <div class="dim">No result</div>
                    </template>

                    <template #item-@="{ item }">
                      <div class="user">
                        {{ item.firstName + " " + item.lastName }}
                      </div>
                    </template>
                  </Mentionable>
                </div>

                <div
                  v-if="!(showDicussion && activeDiscussionItem.id == item.id)"
                >
                  <div
                    style="padding-top: 0; padding-bottom: 10px; margin-left: 10px;"
                    class="d-flex companyProfileCardsAddButton add-item"
                    @click="discussionChecklistItem(item)"
                  >
                    <div>Reply</div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="showAddChecklistItem">
                <div class="col-12">
                  <Mentionable
                    :keys="['@']"
                    :items="people"
                    offset="6"
                    insert-space
                  >
                    <input
                      type="text"
                      class="form-control team-form"
                      style="width: 100%"
                      v-model="newChecklistItemSummary"
                      placeholder="Add a new checklist item"
                    />
                    <template #no-result>
                      <div class="dim">No result</div>
                    </template>

                    <template #item-@="{ item }">
                      <div class="user">
                        {{ item.firstName + " " + item.lastName }}
                      </div>
                    </template>
                  </Mentionable>
                </div>

              <div
                class="col-3 edit-company-action-button-row"
                style="margin-top: 30px"
              >
                <button
                  type="button"
                  class="todo-form-cancel-button btn-outline-secondary"
                  @click.prevent="handleCancelChecklistItem"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="todo-form-submit-button btn btn-primary"
                  @click.prevent="handleSaveChecklistItem"
                  :disabled="showSaveChecklistItemSpinner"
                >
                  Save
                  <b-spinner
                    v-if="showSaveChecklistItemSpinner"
                    style="float: right"
                    small
                    label="Loading..."
                  ></b-spinner>
                </button>
              </div>
            </div>
            <el-dialog
              center
              width="30%"
              title="Add Checklist"
              :closeOnClickModal="false"
              :closeOnPressEscape="false"
              :showClose="false"
              :visible.sync="isShowAddChecklist"
            >
              <div class="row">
                <div class="col-12">
                  <div class="formLabel">Checklist name</div>
                  <input
                    type="text"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="newChecklist"
                    placeholder="# e.g General"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="formLabel">Copy items from existing</div>
                  <el-select
                    class="checklist-el-select"
                    size="small"
                    v-model="newChecklistCopyFromExisting"
                  >
                    <el-option
                      class="select-primary sizingSelect"
                      v-for="option in accountChecklist"
                      :value="option._id"
                      :label="option.name"
                      :key="option._id"
                    ></el-option>
                  </el-select>
                </div>
              </div>

              <div class="col-12 text-right btn-wrapper">
                <button
                  type="button"
                  class="todo-form-cancel-button btn-outline-secondary"
                  @click.prevent="handleCancelChecklistCreate()"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  @click.prevent="handleSaveChecklist()"
                  class="todo-form-submit-button btn btn-primary"
                  style="height: 35px; margin-left: 15px"
                  :disabled="!newChecklist"
                >
                  Save
                  <b-spinner
                    v-if="showSaveChecklistLoader"
                    style="float: right"
                    small
                    label="Loading..."
                  ></b-spinner>
                </button>
              </div>
            </el-dialog>

            <div v-if="!showAddChecklistItem">
              <div
                class="d-flex companyProfileCardsAddButton add-item"
                @click="handleAddChecklistItem"
              >
                <div>
                  <i class="fa fa-plus" style="font-size: 8px"></i>
                </div>
                <div>Add Item</div>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { vals } from "../../../util";
import swal from "sweetalert2";
import api from "../../../axios_api";
import moment from "moment";
import { mapGetters } from "vuex";
import { Mentionable } from "vue-mention";
import { Dialog, Select, Option } from "element-ui";
import ChecklistName from "../../../components/ChecklistName.vue";

export default {
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    Mentionable,
    ...mapGetters("team", ["getAllUsers"]),
    [ChecklistName.name]: ChecklistName
  },
  computed: {
    moment() {
      return moment;
    },
    currentCompany() {
      return this.$store.getters["temp/currentPortfolioItems"](
        this.$route.params.ucid
      );
    }
  },
  data() {
    return {
      isShowAddChecklist: false,
      newChecklist: "",
      newChecklistCopyFromExisting: "",
      showSaveChecklistLoader: false,
      portfolioChecklist: [],
      accountChecklist: [],
      deleteChecklist: false,
      deleteChecklistObject: null,
      checklist: null,
      showAddChecklistItem: false,
      newChecklistItemSummary: "",

      showSaveChecklistItemSpinner: false,
      showSaveCheck: false,
      currentItemId: "",

      itemToEdit: null,

      idWiseUsers: {},
      showDicussion: false,
      showSaveDiscussionSpinner: false,
      activeDiscussionItem: null,
      showDicussionEdit: false,
      activeDiscussionEditItem: null,

      showDeleteChecklistItemSpinner: false,
      people: [],

      showAddDescription: false,
      showSaveChecklistDescriptionSpinner: false
    };
  },
  methods: {
    getAllChecklist(){
      this.$store.dispatch("checklist/apiFetchAllChecklist").then(res=>{
        this.accountChecklist = res;
      })
    },
    handleCancelChecklistCreate() {
      this.newChecklist = "";
      this.newChecklistCopyFromExisting = "";

      this.isShowAddChecklist = false;
    },
    async handleSaveChecklist() {
      let self = this;

      self.showSaveChecklistLoader = true;

      let copiedChecklist = [];

      if (self.newChecklistCopyFromExisting) {
        let found = self.accountChecklist.find(item => {
          return item._id == self.newChecklistCopyFromExisting;
        });

        if (found) {
          copiedChecklist = found.checklist_items.map((clItm, idx) => {
            return {
              id: Date.now() + "_" + idx,
              summary: clItm.summary,
              is_done: false,
              discussions: []
            };
          });
        }
      }

      self.$store
        .dispatch("checklist/apiPostChecklist", {
          portfolio_item: self.currentCompany._id,
          name: self.newChecklist,
          copiedChecklistItems: copiedChecklist
        })
        .then(res => {
          console.log(res);
          self.getChecklistItems();
          self.showSaveChecklistLoader = false;
          self.isShowAddChecklist = false;
          self.$router.push(
            `/${res.created_by}/${res.workspace}/checklist/${res.portfolio_item}/${self.$route.params.ucid}/${res._id}`
          );
        })
        .catch(err => {
          console.log("err: ", err);
          self.showSaveChecklistLoader = false;
        });
    },
    handleCreateChecklist() {
      this.isShowAddChecklist = true;
    },
    deleteChecklistModal(data) {
      this.deleteChecklist = true;
      this.deleteChecklistObject = null;

      this.deleteChecklistObject = data;
    },
    handleCancelDeleteChecklist() {
      // this.deleteData = {};
      this.deleteChecklist = false;
    },
    handleDeleteChecklist() {
      let self = this;

      self.showDeleteChecklistItemSpinner = true;
      api
        .delete(
          `/${self.$route.params.account_id}/${this.deleteChecklistObject.workspace}/${this.deleteChecklistObject.portfolio_item}/checklist/${this.deleteChecklistObject._id}`
          // {
          //   encrypt: {
          //     data: {
          //       is_done: item.is_done,
          //       summary: item.summary
          //     }
          //   }
          // }
        )
        .then(res => {
          self.$store
            .dispatch(
              "checklist/apiDeleteChecklist",
              self.deleteChecklistObject._id
            )
            .then(data => {
              self.getChecklistItems();
              self.getAllChecklist();
              self.deleteChecklist = false;
              self.handleBack();
            })
            .catch(error => {
              self.$toaster.error("Failed to delete round !!!");
            });
        })
        .catch(error => {
          this.$toaster.error("Failed to Delete Todo..!!");
        });
    },
    getChecklistItems() {
      let self = this;
      self.$store
        .dispatch("checklist/apiFetchChecklist")
        .then(async () => {
          self.getChecklistById();
          self.getChecklistByPortfolio();
        })
        .catch(error => {
          console.log("error in fetching checklist", error);
        });
    },
    getChecklistByPortfolio() {
      let self = this;
      if (self.currentCompany) {
        let portfolioChecklist = self.$store.getters[
          "checklist/checklistByPortfolioId"
        ](self.currentCompany._id);
        // console.log('portfolio checklist' )
        self.portfolioChecklist = portfolioChecklist || [];
      }
    },
    getChecklistById() {
      let self = this;

      let portfolioChecklist = self.$store.getters[
        "checklist/checklistByPortfolioId"
      ](self.$route.params.portfolio_item);

      self.checklist = portfolioChecklist.find(item => {
        return item._id == self.$route.params.checklist_id;
      });
    },
    completedChecklistItemCount(clItems) {
      return clItems.filter(item => {
        return item.is_done;
      }).length;
    },

    handleAddChecklistItem() {
      this.showAddChecklistItem = true;
    },
    handleCancelChecklistItem() {
      this.showSaveChecklistItemSpinner = false;
      this.newChecklistItemSummary = "";
      this.showAddChecklistItem = false;
    },
    urlify(text) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function(url) {
        return '<a href="' + url + '">' + url + '</a>';
      })
      // or alternatively
      // return text.replace(urlRegex, '<a href="$1">$1</a>')
    },
    async handleSaveChecklistItem() {
      let self = this;
      self.showSaveChecklistItemSpinner = true;
      this.newChecklistItemSummary = this.urlify(this.newChecklistItemSummary);
      try {
        await api.post(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.$route.params.checklist_id}/checklist_item`,
          {
            encrypt: {
              data: {
                id:
                  Date.now() + "_" + self.checklist.checklist_items.length || 1,
                summary: self.newChecklistItemSummary,
                is_done: false,
                discussions: []
              }
            }
          }
        );

        self.getChecklistItems();
      } catch (e) {
        console.log("error: ", e);
      }

      self.handleCancelChecklistItem();
    },
    async handleCheck(item, isDone) {
      let self = this;
      self.showSaveCheck = true;
      self.currentItemId = item.id;

      try {
        await api.put(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.$route.params.checklist_id}/checklist_item/${item.id}`,
          {
            encrypt: {
              data: {
                is_done: isDone
              }
            }
          }
        );

        self.getChecklistItems();
      } catch (e) {
        console.log("error: ", e);
      }

      self.showSaveCheck = false;
      self.currentItemId = "";
    },

    editChecklistItem(item) {
      let self = this;

      self.itemToEdit = item;
    },
    discussionChecklistItem(item) {
      let self = this;
      self.showDicussion = true;
      self.activeDiscussionItem = item;
    },
    async deleteChecklistItem(item) {
      let self = this;

      self.showDeleteChecklistItemSpinner = true;

      try {
        await api.delete(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.$route.params.checklist_id}/checklist_item/${item.id}`,
          {
            encrypt: {
              data: {
                is_done: item.is_done,
                summary: item.summary
              }
            }
          }
        );
        self.getChecklistItems();
      } catch (e) {
        console.log("error: ", e);
      }

      self.showDeleteChecklistItemSpinner = false;
    },

    handleCancelUpdateChecklistItem() {
      let self = this;
      self.itemToEdit = null;
      self.showSaveChecklistItemSpinner = false;
    },
    async handleUpdateChecklistItem(item) {
      let self = this;

      self.showSaveChecklistItemSpinner = true;

      try {
        await api.put(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.$route.params.checklist_id}/checklist_item/${item.id}`,
          {
            encrypt: {
              data: {
                is_done: item.is_done,
                summary: item.summary
              }
            }
          }
        );
        self.handleCancelUpdateChecklistItem();
      } catch (e) {
        console.log("error: ", e);
      }
    },
    async handleDiscussionCreate(item) {
      let self = this;
      self.showSaveDiscussionSpinner = true;

      try {
        await api.post(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.$route.params.checklist_id}/checklist_item/${item.id}/discussion`,
          {
            encrypt: {
              data: {
                id: Date.now() + "_" + item.discussions.length || 1,
                description: item.discussionText
              }
            }
          }
        );

        self.getChecklistItems();
        self.showSaveDiscussionSpinner = false;
        self.showDicussion = false;
      } catch (e) {
        console.log("error: ", e);
      }

      self.handleCancelChecklistItem();
    },
    async handleDiscussionUpdate(item, discussion) {
      let self = this;
      self.showSaveDiscussionSpinner = true;

      try {
        await api.put(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.$route.params.checklist_id}/checklist_item/${item.id}/discussion/${discussion.id}`,
          {
            encrypt: {
              data: {
                description: discussion.description
              }
            }
          }
        );

        self.getChecklistItems();
        self.showSaveDiscussionSpinner = false;
        self.showDicussionEdit = false;
        self.activeDiscussionEditItem = null;
      } catch (e) {
        console.log("error: ", e);
      }

      self.showSaveDiscussionSpinner = false;
    },
    editDiscussionItem(discussion, item) {
      let self = this;
      self.activeDiscussionEditItem = discussion;
      self.showDicussionEdit = true;
    },
    async deleteDiscussionItem(discussion, item) {
      let self = this;

      self.showDeleteDiscussionSpinner = true;

      try {
        await api.delete(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.$route.params.checklist_id}/checklist_item/${item.id}/discussion/${discussion.id}`,
          {
            encrypt: {
              data: {
                is_done: item.is_done,
                summary: item.summary
              }
            }
          }
        );
        self.getChecklistItems();
      } catch (e) {
        console.log("error: ", e);
      }

      self.showDeleteDiscussionSpinner = false;
    },

    handleAddDescription() {
      this.showAddDescription = true;
    },
    handleCancelDescription() {
      this.showAddDescription = false;
    },
    async handleUpdateChecklistDescription() {
      let self = this;

      self.showSaveChecklistDescriptionSpinner = true;

      try {
        await api.put(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.$route.params.checklist_id}`,
          {
            encrypt: {
              data: {
                description: self.checklist.description
              }
            }
          }
        );

        self.getChecklistItems();
      } catch (e) {
        console.log("error: ", e);
      }

      self.showSaveChecklistDescriptionSpinner = false;
      self.showAddDescription = false;
    },
    handleBack() {
      window.history.back();
    }
  },
  created(){
    this.getAllChecklist();
  },
  mounted() {
    let self = this;
    self.getChecklistItems();

    let allUsers = self.$store.getters["team/getAllUsers"];

    allUsers.forEach(item => {
      self.idWiseUsers[item.account._id] = item;
    });
    self.people = allUsers.map(item => {
      return {
        firstName: item.account.firstName,
        lastName: item.account.lastName,
        label: item.account.firstName + " " + item.account.lastName,
        value: item.account.firstName
      };
    });
    // console.log("this.people: ", self.people);
  },
  watch: {
    checklist: {
      handler() {
        // console.log("checklist: ", this.checklist);
      }
    },
    team: {
      handler() {
        // console.log("team: ", this.team, this.people);
        this.people = this.team;
      }
    }
  }
};
</script>
<style>
.companyProfileCardsAddButton.add-item {
  font-size: 12px;
}

.checklist-item-row {
  padding: 0 5px;
  transition: all 0.3s ease 0s;
  border-radius: 4px;
}

.checklist-item-row-wrapper {
  margin-bottom: 5px;
}
.checklist-item-row-wrapper:hover {
  background-color: #e4e4e4;
  transition: all 0.3s ease 0s;
  border-radius: 4px;
}

.menu-wrapper {
  opacity: 0;
}

.checklist-item-row-wrapper:hover .menu-wrapper {
  opacity: 1;
}

.discussion-row {
  background: hsla(245, 88%, 61%, 0.1) 0% 0% no-repeat padding-box;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 0px 0 10px 0;
}
.discussion-wrapper {
  padding: 0 33px;
}
.discussion-input {
  width: 100%;
  height: 85px;
  border: 0.5px solid #000000;
  border-radius: 5px;
  opacity: 1;
  padding: 5px;
  font-size: 12px;
  line-height: 1.5;
}
.discussion-input-value {
  width: 588px;
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
}
.discussion-text {
  text-align: left;
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #00000080;
  opacity: 1;
}
.discussion-user-name {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
.discussion-user-date {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #00000080;
  opacity: 1;
  margin-left: 20px;
}

.add-description {
  opacity: 0;
  transition: all 0.3s ease 0s;
}
.checklist-name-wrapper:hover {
  background-color: #e4e4e4;
}
.checklist-name-wrapper:hover .add-description {
  opacity: 1;
}
.checklist-name-wrapper {
  transition: all 0.3s ease 0s;
  border-radius: 4px;
  padding: 0 10px;
  align-items: center;
  min-height: 28px;
}
.add-desc {
  padding-top: 0;
  margin-left: 20px;
}

.checklist-item-row-wrapper .btn-sm {
  padding: 0;
  margin: 0;
  line-height: 7px;
}

.checklist-item a{
  word-break: break-all;
}

</style>
